import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { X } from 'lucide-react';
import { Link } from 'react-router-dom';

export const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already consented
    const hasConsented = localStorage.getItem('cookie-consent');
    if (!hasConsented) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie-consent', 'true');
    setIsVisible(false);
  };

  const handleDismiss = () => {
    localStorage.setItem('cookie-consent', 'true');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-card border-t border-border shadow-lg animate-in slide-in-from-bottom duration-500">
      <div className="container mx-auto px-4 py-4 sm:py-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="flex-1 text-sm text-muted-foreground pr-4">
            <p className="mb-2 font-medium text-foreground">
              🍪 This website uses cookies
            </p>
            <p>
              We use cookies for security and to remember your preferences. 
              By continuing to use this site, you consent to our use of cookies.{' '}
              <Link 
                to="/cookie-policy"
                className="text-primary hover:underline"
              >
                Read our Cookie Policy
              </Link>
            </p>
          </div>
          <div className="flex items-center gap-2 w-full sm:w-auto">
            <Button 
              onClick={handleAccept}
              className="flex-1 sm:flex-none"
            >
              Accept
            </Button>
            <Button 
              onClick={handleDismiss}
              variant="ghost"
              size="icon"
              className="shrink-0"
              aria-label="Dismiss cookie notice"
            >
              <X className="h-4 w-4" />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
